module.exports = __webpack_public_path__ + "media/customer_tickets/warranty-af8428c2.svg";